import queryString from "query-string";
import {
  setCouponsCopy,
  updateCouponCopy,
  addCouponCopy,
} from "./appifyActions";
import { privateFetch } from "apis";
import { removeEmptyParams, SecureLocalStorage } from "helpers";

// Deal Action Dispatchers
export const setCoupons = (coupons) => ({
  type: "SET_COUPONS",
  coupons,
});

export const removeCoupons = () => ({
  type: "REMOVE_COUPONS",
});

export const removeCoupon = (coupon) => ({
  type: "REMOVE_COUPON",
  coupon,
});

export const updateCoupon = (coupon) => ({
  type: "UPDATE_COUPON",
  coupon,
});

export const addTempCoupon = () => ({
  type: "ADD_TEMP_COUPON",
});

export const updateTempCoupon = (coupon) => ({
  type: "UPDATE_TEMP_COUPON",
  coupon,
});

// GET all deals associated with an appId
export const getCoupons = (appId) => (dispatch) => {
  const url = `${__BASE_API_URL__}/app/${appId}/coupons?includeRetired=true`;

  return privateFetch(url, {
    method: "GET",
  }).then((coupons) => {
    dispatch(setCoupons(coupons));
    dispatch(setCouponsCopy(coupons));
    return coupons;
  });
};

// Save a deal
export const createCoupon = (appId, coupon) => async (dispatch) => {
  const newCoupon = await postCoupon(appId, coupon);
  dispatch(updateTempCoupon(newCoupon));
  dispatch(addCouponCopy(newCoupon));
  return newCoupon;
};

// POST a Coupon to the database
const postCoupon = (appId, coupon) => {
  const url = __BASE_API_URL__ + `/app/${appId}/coupon`;
  if (coupon.id === "newCoupon") {
    // console.log("setting clone as new store item");
    delete coupon.id;
  }

  return privateFetch(url, {
    method: "POST",
    body: JSON.stringify(coupon),
  }).then((coupon) => {
    return coupon;
  });
};

// DELETE a Coupon in database
export const deleteCoupon = (coupon, appId) => (dispatch) => {
  const url = __BASE_API_URL__ + `/coupon/${coupon.id}`;

  return privateFetch(url, {
    method: "DELETE",
  }).then((res) => {
    if (res) {
      console.log("got delete object back");
      console.dir(res);
      dispatch(updateCoupon(res));
      dispatch(updateCouponCopy(res));
      dispatch(getCoupons(appId));
    }
  });
};
